import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationService } from '@/services/notification.service';
import { newsLetterService } from '@/services/news_letter.service';
import { NewsLetterError } from '@/exceptions/news_letter/news.enum';

const useCreateNewsLetter = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (newsLetter: FormData) =>
            await newsLetterService.newNewsLetter(newsLetter),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['newsLetter'] });
            notificationService.success("NewsLetter Created Succesful");

        },

        onError: () => {
            throw new Error(NewsLetterError.CREATE_ERROR);
        },
    });
};

export default useCreateNewsLetter;
